export default __webpack_public_path__ + "static/media/logo.311556d3.png";